import { InsuranceType, InsuranceTypeDto, insuranceTypeToDto } from '@models/insurance-type';
import { InsuredObjectDto, insuredObjectToDto } from '@models/insured-object';
import { Product } from '@models/product';
import { finalizeInsurants, OrderState } from './order-state.model';
import { findViableContractStartDate } from 'app/utils/helper.functions';
import { InsurantDto } from '@models/insurant';

export interface PriceRequestDto {
    // contract data
    InsuranceType: InsuranceTypeDto;
    ContractStart: string;
    ContractPeriod: number;

    // object pool:
    ObjectPool: InsuredObjectDto[];

    // can we scrap that and make it a pool object?
    InsuranceObjectId: number | null;
    ObjectValue: number | null;

    Insurants: InsurantDto[];
}

export function getPriceRequestDto(state: OrderState, product: Product, insuranceType: InsuranceType): PriceRequestDto {
    return {
        // contract data
        InsuranceType: insuranceTypeToDto(insuranceType),
        ContractStart:
            state.contract?.contractStart || findViableContractStartDate(product.orderConfig.contractStartMode),
        ContractPeriod: state.contract?.contractPeriod || 0,

        // object pool:
        ObjectPool: (state.insuredObjects || []).map((insuredObject) => insuredObjectToDto(insuredObject)),

        // can we scrap that and make it a pool object?
        InsuranceObjectId:
            typeof state.insuredObjects[0]?.description === 'number' ? state.insuredObjects[0].description : null,
        ObjectValue: typeof state.insuredObjects[0]?.value === 'number' ? state.insuredObjects[0].value : null,

        Insurants: finalizeInsurants(state.insurants, state.billingAddress),
    };
}
